module.exports = __webpack_public_path__ + "img/file.48e16b73.jpg";